export default "__VITE_ASSET__DsU6SGGr__"